<template>
  <MultiIndex v-if="isShowGuide" :qdata="qdata" :begin="begin" />
</template>

<script>
import { webcall } from '@hll/driver-js-utils';
import { getAllUrlParams } from '@/tools/other';
import { isInAllApp } from '@/tools/app';
import { envType } from '@/config/host';
import {
  getQuestionInfoApi,
  getQuestionNeedLoginApi,
} from '@/api/modules/question';
import { getAccessTokenApi } from '@/api/modules/index';
import MultiIndex from './components/multi-index.vue';

export default {
  name: 'QuestionGuide',
  components: { MultiIndex },
  data() {
    return {
      pageStatus: '', // 问卷状态：1：正常 2：提前结束 3：过期
      qdata: {},
      isShowGuide: false, // 是否展示引导页，只有多页才展示
    };
  },
  urlParams: {},
  is_login: 0,
  mounted() {
    webcall({ action: 'setTitle', title: '问卷调查' });
    this.urlParams = getAllUrlParams(window.location.href);
    this.getQuestionNeedLogin();
  },
  methods: {
    getQuestionNeedLogin() {
      const params = {
        questionnaire_id: this.urlParams.questionnaire_id,
        original_from: this.urlParams.original_from,
        not_logged_in: 10014,
      };
      if (!isInAllApp && !this.urlParams.original_from) {
        params['original_from'] = 99999999999999;
      }
      getQuestionNeedLoginApi(params).then((res) => {
        if (res.ret == 0) {
          this.is_login = res?.data?.is_login;
          this.initInfo();
        } else {
          this.$hll.toast(res.msg);
        }
        console.log('res===>', res);
      });
    },
    // 问卷详情
    initInfo() {
      /**
       * 如果问卷本身需要登录，即要验证token，不需要登录就不要验证token
       * 未登录状态需要限制次数吗 ===> 最新情报不需要限制
       */
      const params = {
        questionnaire_id: this.urlParams.questionnaire_id,
        push_id: this.urlParams.push_id || '',
        original_from: this.urlParams.original_from,
        // is_login=0表示该问卷无需登录，但是端内投放仍需passport登录。除非加上not_logged_in_force=1，则即使投放段内，也无需passport登录。可用于司机未注册场景的端内问卷投放
        not_logged_in:
          this.is_login == '0' &&
          (!isInAllApp || this.urlParams.not_logged_in_force == 1)
            ? 10014
            : undefined,
        // debug: 10000, // 需要本地测试时打开
      };
      if (!isInAllApp && !this.urlParams.original_from) {
        params['original_from'] = 99999999999999;
      }
      getQuestionInfoApi(params).then((res) => {
        if (res.ret == 0) {
          const code = res?.data?.errorCode;
          if (code == 90001 || code == 90002 || code == 90003) {
            const msg = res?.data?.errorMsg;
            // 问卷异常情况下限制作答时 问卷异常状态做特殊处理
            this.$router.replace(`/question/result?status=0&tips=${msg}`);
          } else {
            // 正常情况
            const qdata = res.data || {};
            this.qdata = qdata;
            // 多页需要打开引导页，单页不需要
            if (qdata.page_type == 1) {
              this.begin();
            } else {
              this.isShowGuide = true;
            }
          }
        } else if (res.ret == 10001) {
          this.$hll.toast('请返回登录后作答');
          // this.goToLogin();
        } else {
          this.$hll.toast(res.msg);
        }
      });
    },
    // 跳到主页开始作答
    begin() {
      const qlist = this.qdata?.subject_config?.subjects || [];
      if (qlist.length > 0) {
        sessionStorage.setItem('questionnaire', JSON.stringify(this.qdata));
        this.$router.replace({
          name: 'question/subject',
          query: { ...this.urlParams, is_login: this.is_login },
        });
      } else {
        this.$hll.toast('问卷题目数量异常');
      }
    },

    // 去登录
    // goToLogin() {
    //   getAccessTokenApi().then((res) => {
    //     const data = res.data;
    //     const from_url = encodeURIComponent(window.location.href);
    //     const register_url = `https://dappweb${envType}.xiaolachuxing.com/driver-join/&from_url=${from_url}`;
    //     const loginParams = `access_token=${data.access_token}&register_url=${register_url}`;
    //     window.location.href = `https://passport${envType}.xiaolachuxing.com?${loginParams}`;
    //   });
    // },
  },
};
</script>
